//export const baseUrl = 'http://192.168.0.48:8080/'
export const baseUrl = 'https://services.eudeliv.com/'
//export const baseUrl = 'http://localhost:8080/'